import Marionette from "backbone.marionette";

export default Backbone.Collection.extend({
    url: "api/users/index.php",
    //Overwrite behaviour for Hal+JSON data
    parse: function(data) {
        this.pageAttributes = {
            page: data.page,
            page_count: data.page_count,
            page_size: data.page_size,
            total_items: data.total_items,
        };

        this.available = data.available //Clients and instances visible for the user
        this.lang = data.lang;
        return data._embedded;
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/collections/usersCollection.js
// module id = 170
// module chunks = 0